import { ReactComponent as Signal } from 'design_system/src/static/icons/radio-signal.svg';
import { ReactComponent as NoSignal } from 'design_system/src/static/icons/no-radio-signal.svg';
import { ReactComponent as Home } from 'design_system/src/static/icons/temple.svg';
import { ReactComponent as Tile } from 'design_system/src/static/icons/gps.svg';
import { ReactComponent as Hotspot } from 'design_system/src/static/icons/pin-location.svg';
import { ReactComponent as Account } from 'design_system/src/static/icons/user-circle.svg';

/* eslint-disable no-shadow */
export enum RepossessionPolicy {
	overdue = 'overdue',
	writeOff = 'writeOff',
	priority = 'priority',
	devolution = 'devolution',
}

// eslint-disable-next-line import/export
export enum RepossessionsLocationTypes {
	address = 'address',
	geolocation = 'geolocation',
	gps = 'gps',
}

export const RepossessionPolicyValues: {
	[key in RepossessionPolicy]: { title: string; color: string };
} = {
	[RepossessionPolicy.priority]: {
		title: 'Prioritario',
		color: 'primary_300',
	},
	[RepossessionPolicy.overdue]: {
		title: 'Mora',
		color: 'red_300',
	},
	[RepossessionPolicy.devolution]: {
		title: 'Devolución',
		color: 'neutral_600',
	},
	[RepossessionPolicy.writeOff]: {
		title: 'WriteOff',
		color: 'neutral_900',
	},
};

export enum RepossessionStatus {
	pending = 'pending',
	completed = 'completed',
	failed = 'failed',
	canceled = 'canceled',
}

export enum InterestPointType {
	hotspot = 'hotspot',
	signalTileVehicle = 'signalTileVehicle',
	noSignalTileVehicle = 'noSignalTileVehicle',
	signalVehicle = 'signalVehicle',
	noSignalVehicle = 'noSignalVehicle',
	address = 'address',
	geolocation = 'geolocation',
}

export const InterestPointTypeValues = {
	[InterestPointType.signalTileVehicle]: {
		title: 'Ubicación actual Tile (<24h)',
		score: 4,
		icon: Tile,
		color: 'green',
		realColor: 'green_300',
	},
	[InterestPointType.noSignalTileVehicle]: {
		title: 'Última ubicación Tile (>24h)',
		score: 1,
		icon: Tile,
		color: 'red',
		realColor: 'red_300',
	},
	[InterestPointType.signalVehicle]: {
		title: 'Ubicación actual (<24h)',
		score: 4,
		icon: Signal,
		color: 'green',
		realColor: 'green_300',
	},
	[InterestPointType.noSignalVehicle]: {
		title: 'Última ubicación (>24h)',
		score: 1,
		icon: NoSignal,
		color: 'red',
		realColor: 'red_300',
	},
	[InterestPointType.address]: {
		title: 'Domicilio',
		score: 3,
		icon: Home,
		color: 'primary',
		realColor: 'primary_300',
	},
	[InterestPointType.geolocation]: {
		title: 'Ingreso a mi cuenta',
		score: 2,
		icon: Account,
		color: 'secondary',
		realColor: 'secondary_500',
	},
	[InterestPointType.hotspot]: {
		title: 'Hotspot',
		score: 0,
		icon: Hotspot,
		color: 'yellow',
		realColor: 'yellow_100',
	},
};

export enum InterestPointStatus {
	active = 'active',
	expired = 'expired',
}

export enum LocationType {
	signalVehicle = 'signalVehicle',
	noSignalVehicle = 'noSignalVehicle',
	gpsTraker = 'gpsTraker',
}

export enum LocationTypes {
	signalVehicle = 'signalVehicle',
	noSignalVehicle = 'noSignalVehicle',
	gpsTraker = 'gpsTraker',
}

export enum RepossessionEvidenceType {
	recoveryOnSite = 'recoveryOnSite',
	vehicleFront = 'vehicleFront',
	vehicleBack = 'vehicleBack',
	vehicleRight = 'vehicleRight',
	vehicleLeft = 'vehicleLeft',
	vehiclePanel = 'vehiclePanel',
}

export const RepossessionEvidenceTypeValues = {
	[RepossessionEvidenceType.recoveryOnSite]: 'Recuperacion en sitio',
	[RepossessionEvidenceType.vehicleFront]: 'Foto Frontal del vehículo',
	[RepossessionEvidenceType.vehicleBack]: 'Foto Trasera del vehículo',
	[RepossessionEvidenceType.vehicleRight]: 'Foto Lateral Derecha del vehículo',
	[RepossessionEvidenceType.vehicleLeft]: 'Foto Lateral Izquierda del vehículo',
	[RepossessionEvidenceType.vehiclePanel]: 'Foto del panel del vehículo',
};
